import { api } from "#app/http/api";

export const replayOnboarding = async () => {
  const response = await api.company.replayOnboarding.mutation({
    body: undefined,
  });

  if (response.status !== 200) {
    throw new Error("Failed to replay onboarding");
  }

  return response.body;
};
